export default __webpack_public_path__ + "static/media/hackMOL2.a0ca36a5.jpg";